import styled from 'styled-components';

const StyledError = styled.div`
  background: #fcebf1;
  border-radius: 8px;
  padding-bottom: 30px;
  padding-top: 1px;
  margin-top: 20px;
  button {
    background: black;
    border: black;
    margin-top: 15px;
  }
`;
export default StyledError;
